import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../api/axios';

const DEPARTMENTS = ['Administration', 'Engineering', 'Finance', 'HR', 'IT', 'Marketing', 'Operations', 'Sales', 'Security', 'Other'];

export default function Register() {
  const [form, setForm] = useState({
    full_name: '', staff_id: '', email: '', phone: '', department: '', password: '', confirm_password: ''
  });
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  function validate() {
    const e = {};
    if (!form.full_name.trim()) e.full_name = 'Full name is required';
    if (!form.staff_id.trim()) e.staff_id = 'Staff ID is required';
    if (!/\S+@\S+\.\S+/.test(form.email)) e.email = 'Valid email required';
    if (!form.department) e.department = 'Department is required';
    if (form.password.length < 8) e.password = 'At least 8 characters';
    else if (!/[A-Z]/.test(form.password)) e.password = 'Must include uppercase letter';
    else if (!/[0-9]/.test(form.password)) e.password = 'Must include a number';
    if (form.password !== form.confirm_password) e.confirm_password = 'Passwords do not match';
    return e;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const e2 = validate();
    if (Object.keys(e2).length > 0) { setErrors(e2); return; }
    setErrors({});
    setApiError('');
    setLoading(true);

    try {
      const { confirm_password, ...data } = form;
      const res = await api.post('/auth/register', data);
      login(res.data.token, res.data.user);
      navigate('/dashboard');
    } catch (err) {
      setApiError(err.response?.data?.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  }

  function field(name) {
    return {
      value: form[name],
      onChange: e => { setForm({ ...form, [name]: e.target.value }); setErrors({ ...errors, [name]: '' }); },
      className: `form-input${errors[name] ? ' error' : ''}`,
    };
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <div style={{ fontSize: '2.5rem' }}>📋</div>
          <h1 style={{ fontSize: '1.5rem', fontWeight: 700, marginTop: '0.5rem' }}>Create Account</h1>
          <p style={{ color: '#64748b', fontSize: '0.875rem' }}>Join AttendTrack to manage your attendance</p>
        </div>

        {apiError && <div className="alert alert-error">{apiError}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Full Name *</label>
              <input type="text" placeholder="John Doe" {...field('full_name')} />
              {errors.full_name && <p className="form-error">{errors.full_name}</p>}
            </div>
            <div className="form-group">
              <label className="form-label">Staff ID *</label>
              <input type="text" placeholder="EMP-001" {...field('staff_id')} />
              {errors.staff_id && <p className="form-error">{errors.staff_id}</p>}
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Email Address *</label>
              <input type="email" placeholder="john@company.com" {...field('email')} />
              {errors.email && <p className="form-error">{errors.email}</p>}
            </div>
            <div className="form-group">
              <label className="form-label">Phone Number</label>
              <input type="tel" placeholder="+1 234 567 8900" {...field('phone')} />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Department *</label>
            <select className={`form-input${errors.department ? ' error' : ''}`} value={form.department}
              onChange={e => { setForm({ ...form, department: e.target.value }); setErrors({ ...errors, department: '' }); }}>
              <option value="">Select department</option>
              {DEPARTMENTS.map(d => <option key={d} value={d}>{d}</option>)}
            </select>
            {errors.department && <p className="form-error">{errors.department}</p>}
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Password *</label>
              <input type="password" placeholder="Min 8 chars, uppercase & number" {...field('password')} />
              {errors.password && <p className="form-error">{errors.password}</p>}
            </div>
            <div className="form-group">
              <label className="form-label">Confirm Password *</label>
              <input type="password" placeholder="Repeat password" {...field('confirm_password')} />
              {errors.confirm_password && <p className="form-error">{errors.confirm_password}</p>}
            </div>
          </div>

          <button type="submit" className="btn btn-primary btn-block btn-lg" disabled={loading} style={{ marginTop: '0.5rem' }}>
            {loading ? <><span className="spinner" /> Creating account...</> : 'Create Account'}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: '1.25rem', color: '#64748b', fontSize: '0.875rem' }}>
          Already have an account?{' '}
          <Link to="/login" style={{ color: '#2563eb', fontWeight: 500 }}>Sign in</Link>
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #dbeafe 0%, #e0e7ff 100%)', padding: '1rem' },
  card: { background: '#fff', borderRadius: 16, padding: '2rem', width: '100%', maxWidth: 580, boxShadow: '0 20px 60px rgba(0,0,0,0.1)' },
};
